module.exports = __webpack_public_path__ + "r-v3/img/virtual_background_outside_02.d1db1d92.png";